// Türkiye'de yaygın araç markaları ve modelleri
export const carBrands = [
  {
    name: 'Alfa Romeo',
    models: ['Giulia', 'Giulietta', 'Stelvio', 'Tonale']
  },
  {
    name: 'Audi',
    models: ['A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q2', 'Q3', 'Q5', 'Q7', 'Q8', 'e-tron', 'TT', 'R8']
  },
  {
    name: 'BMW',
    models: ['1 Serisi', '2 Serisi', '3 Serisi', '4 Serisi', '5 Serisi', '6 Serisi', '7 Serisi', '8 Serisi', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'iX', 'i4', 'Z4']
  },
  {
    name: 'Chery',
    models: ['Tiggo 7', 'Tiggo 8']
  },
  {
    name: 'Chevrolet',
    models: ['Aveo', 'Cruze', 'Captiva', 'Trax']
  },
  {
    name: 'Citroën',
    models: ['C3', 'C3 Aircross', 'C4', 'C5 Aircross', 'Berlingo']
  },
  {
    name: 'Dacia',
    models: ['Duster', 'Sandero', 'Logan', 'Jogger', 'Spring']
  },
  {
    name: 'DS',
    models: ['DS 3', 'DS 4', 'DS 7']
  },
  {
    name: 'Fiat',
    models: ['500', '500X', 'Egea', 'Tipo', 'Doblo', 'Panda']
  },
  {
    name: 'Ford',
    models: ['Fiesta', 'Focus', 'Mondeo', 'Puma', 'Kuga', 'Transit', 'Ranger', 'Mustang']
  },
  {
    name: 'Honda',
    models: ['Civic', 'CR-V', 'HR-V', 'Jazz']
  },
  {
    name: 'Hyundai',
    models: ['i10', 'i20', 'i30', 'Bayon', 'Kona', 'Tucson', 'Santa Fe', 'Ioniq', 'Elantra']
  },
  {
    name: 'Jeep',
    models: ['Renegade', 'Compass', 'Wrangler', 'Grand Cherokee']
  },
  {
    name: 'Kia',
    models: ['Picanto', 'Rio', 'Stonic', 'Ceed', 'XCeed', 'Sportage', 'Sorento', 'EV6']
  },
  {
    name: 'Land Rover',
    models: ['Defender', 'Discovery', 'Discovery Sport', 'Range Rover', 'Range Rover Sport', 'Range Rover Evoque', 'Range Rover Velar']
  },
  {
    name: 'Mazda',
    models: ['2', '3', '6', 'CX-3', 'CX-5', 'CX-30', 'CX-60', 'MX-5']
  },
  {
    name: 'Mercedes-Benz',
    models: ['A Serisi', 'B Serisi', 'C Serisi', 'E Serisi', 'S Serisi', 'CLA', 'CLS', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'EQA', 'EQB', 'EQC', 'EQE', 'EQS']
  },
  {
    name: 'Mini',
    models: ['Cooper', 'Countryman', 'Clubman']
  },
  {
    name: 'Nissan',
    models: ['Micra', 'Juke', 'Qashqai', 'X-Trail', 'Leaf']
  },
  {
    name: 'Opel',
    models: ['Corsa', 'Astra', 'Insignia', 'Crossland', 'Grandland', 'Mokka', 'Combo']
  },
  {
    name: 'Peugeot',
    models: ['208', '308', '2008', '3008', '5008', 'Rifter', 'Partner']
  },
  {
    name: 'Porsche',
    models: ['911', 'Cayenne', 'Macan', 'Panamera', 'Taycan']
  },
  {
    name: 'Renault',
    models: ['Clio', 'Megane', 'Taliant', 'Captur', 'Kadjar', 'Arkana', 'Koleos', 'Kangoo', 'Zoe']
  },
  {
    name: 'Seat',
    models: ['Ibiza', 'Leon', 'Arona', 'Ateca', 'Tarraco']
  },
  {
    name: 'Skoda',
    models: ['Fabia', 'Scala', 'Octavia', 'Superb', 'Kamiq', 'Karoq', 'Kodiaq', 'Enyaq']
  },
  {
    name: 'Suzuki',
    models: ['Swift', 'Vitara', 'S-Cross', 'Ignis', 'Jimny']
  },
  {
    name: 'Tesla',
    models: ['Model 3', 'Model Y', 'Model S', 'Model X']
  },
  {
    name: 'Toyota',
    models: ['Yaris', 'Corolla', 'Camry', 'C-HR', 'RAV4', 'Highlander', 'Land Cruiser', 'Prius']
  },
  {
    name: 'Volkswagen',
    models: ['Polo', 'Golf', 'Passat', 'Arteon', 'T-Cross', 'T-Roc', 'Tiguan', 'Touareg', 'ID.3', 'ID.4', 'ID.5', 'Caddy', 'Transporter']
  },
  {
    name: 'Volvo',
    models: ['V40', 'V60', 'V90', 'S60', 'S90', 'XC40', 'XC60', 'XC90', 'C40']
  }
];

// Helper function to get models by brand name
export const getModelsByBrand = (brandName) => {
  const brand = carBrands.find(b => b.name === brandName);
  return brand ? brand.models : [];
};
